import { Injectable, inject } from '@angular/core';
import { BrowserApiService } from '../browser-api/browser-api.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private browserApiService = inject(BrowserApiService);


  save(key: string, value: any) {
    const storage = this.browserApiService.getLocalStorage();
    if (storage) {
      storage.setItem(key, JSON.stringify(value));
    }
  }

  retrieve(key: string): any {
    const storage = this.browserApiService.getLocalStorage();
    if (storage) {
      const item = storage.getItem(key);
      return item ? JSON.parse(item) : null;
    }
    return null;
  }

  remove(key: string) {
    const storage = this.browserApiService.getLocalStorage();
    if (storage) {
      storage.removeItem(key);
    }
  }

  setByProperty(key: string, prop: string, propValue: string) {
    const storage = this.browserApiService.getLocalStorage();
    if (storage) {
      const item = storage.getItem(key);
      const result = item ? JSON.parse(item) : {};
      result[prop] = propValue ?? '';
      this.save(key, result);
    }
  }
}
